import { isEmail, isRequired } from "evcharging/app/validation/validators";
import { httpClient } from "evcharging/app/client";
import { EMAIL_SEND_INQUIRE_ENDPOINT } from "config/email/endpoints";

const validators = {
  fullName: [isRequired],
  email: [isRequired, isEmail],
  phone: [isRequired],
};

const sendRetailInquire = (payload: Record<string, string>) =>
  httpClient()
    .setBody(payload)
    .setValidators(validators)
    .post(EMAIL_SEND_INQUIRE_ENDPOINT);

export default sendRetailInquire;
